import 'core-js/stable'
import 'regenerator-runtime/runtime'
import 'intersection-observer' // Optional
import BootstrapVue, {SpinnerPlugin} from 'bootstrap-vue';
import VModal from 'vue-js-modal';

require('./bootstrap');
require('jquery-ui-bundle');

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
});

// Lunaweb
require('./lunaweb/app.js');

window.Vue = require('vue');

Vue.use(BootstrapVue);
Vue.use(SpinnerPlugin);
Vue.use(VModal);
Vue.use(require('vue-cookies'));

window.Vue.config.devtools = true;
window.Vue.config.debug = true;
window.Vue.config.silent = false;

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// Vue.component('rgpd-info-component', require('./rgpd/RgpdInfoComponent.vue').default);
// Vue.component('rgpd-all-component', require('./rgpd/RgpdAllComponent.vue').default);
// Vue.component('rgpd-config-component', require('./rgpd/RgpdConfigComponent.vue').default);

Vue.component('myfeelback-component', require('./myfeelback/MyfeelbackComponent.vue').default);

//require('./googleanalytics/googleanalytics');
//Vue.component('google-analytics-component', require('./googleanalytics/GoogleAnalyticsComponent.vue').default);

//import VueGtag from "vue-gtag";

//Vue.use(VueGtag, {
//   config: {id: "G-CJYKDXCY7D"}
//})

require('./trustbox/trustbox');
Vue.component('trust-box-component', require('./trustbox/TrustBoxComponent.vue').default);

Vue.component('recaptcha-component', require('./components/RecaptchaComponent.vue').default);

Vue.component(
    'passport-clients',
    require('./components/passport/Clients.vue').default
);

Vue.component(
    'passport-authorized-clients',
    require('./components/passport/AuthorizedClients.vue').default
);

Vue.component(
    'passport-personal-access-tokens',
    require('./components/passport/PersonalAccessTokens.vue').default
);

Vue.component('wcb-isi-com-component', require('./webcallback/WebCallBackIsiComComponent.vue').default);
Vue.component('wcb-bouton-component', require('./webcallback/WebCallBackBoutonComponent.vue').default);
Vue.component('wcb-sticky-component', require('./webcallback/WebCallBackStickyComponent.vue').default);

Vue.component('form-contact-sinistre-component', require('./formcontact-sinistre/FormContactSinistreComponent.vue').default);

Vue.component('prevoyance-component', require('./components/prevoyance/EtapesComponent.vue').default);
Vue.component('sante-component', require('./components/sante/EtapesComponent.vue').default);

Vue.component('aide-completion-apdr-modal', require('./components/AideCompletionApdr.vue').default);

require('./rgpd/rgpd');

let submitter = null;

const app = new Vue({
    el: '#tego',
    mounted() {
        document.addEventListener('ForceRender', (event) => {
            new Vue({
                el: event.detail.selector,
                parent: this
            })
        });
    },
    methods: {
        checkBase64Encode(event) {
            let form = event.target;
            let matches = form.querySelectorAll('[data-base64=encode]');
            matches.forEach(function (item) {
                item.value = btoa(item.value);
            });
        },
        clickSubmit(event) {
            let target = event.target;
            if ($(target).attr('type') == 'submit') {
                submitter = target;
            }
        },
        checkRecaptcha(event) {
            event.preventDefault();
            let form = event.target;
            this.$refs.agpmRecaptcha.AgpmRecaptcha().then(() => {
                $(form).append('<input type="hidden" name="' + $(submitter).attr('name') + '" value="' + $(submitter).attr('value') + '">');
                $(form).submit();
            });
        }
    }
});


require('./loader/loader');

require('./dqe/jquery.dqe');
require('./modal/modalTego.jquery');
require('./modal/modalTego');

require('./dqe/dqe');
require('./multiselect/multiselect.jquery');
require('./multiselect/multiselect');
require('./dynamicchoice/dynamicchoice.jquery');
require('./dynamicchoice/dynamicchoice');
require('./displayselect/displayselect.jquery');
require('./displayselect/displayselect');
require('./autocomplete/autocomplete');
require('./displayinput/displayinput.jquery');
require('./displayinput/displayinput');
require('./displaycheckable/displaycheckable.jquery');
require('./displaycheckable/displaycheckable');
require('./displaychoice/displaychoice.jquery');
require('./displaychoice/displaychoice');
require('./truncate/truncate.jquery');
require('./truncate/truncate');
require('./helpers');
require('./agenceconseiller/agenceconseiller.jquery');
require('./agenceconseiller/agenceconseiller');
require('jquery-mask-plugin');
require('./dateagpm/dateagpm.jquery');
require('./dateagpm/dateagpm');
require('./jquery-mask-plugin/jquery-mask-plugin');
require('./smartbutton/smartbutton.jquery');
require('./smartbutton/smartbutton');
require('./displaydate/displaydate.jquery');
require('./displaydate/displaydate');
require('./displaycalendar/displaycalendar.jquery');
require('./displaycalendar/displaycalendar');
require('./display-or-not/display-or-not');
require('./displaytag/displaytag.jquery');
require('./displaytag/displaytag');
require('./files-upload/files-upload.jquery');
require('./files-upload/files-upload');
require('./displaybutton/displaybutton.jquery');
require('./displaybutton/displaybutton');
require('./aet/ajoutenfant');
require('./gsp/gsp');
require('./range/range');
require('./collapse/collapse');
require('./elodie/elodie');
require('./toaster/toaster');
require('./video-modal/video-modal');
require('./tab-radio/tab-radio');
require('./popover/popover');
require('./showTexte/showTexte');
require('./select-formule/select-formule');
require('./summary-scroll/summary-scroll');
require('./summary-scroll-df/summary-scroll-df');
require('./message-header/message-header');
require('./auto/immat');

require('./resetfield/resetfield');
require('./display/display');
require('./simulation-tarifiaire/objectif-prevoyance/objectif-prevoyance');
require('./simulation-tarifiaire/assurance-perte-de-revenu/simulation');
require('./simulation-tarifiaire/assurance-perte-de-revenu/tarification');
require('./simulation-tarifiaire/assurance-perte-de-revenu/devis');

svg4everybody();

require('./modal-errors');
require('./filtres-hubs');
require('./filter-reclamation');
require('./modal-bienvenue');
require('./modal-voeux');
require('./fix-date');
require('./fix-menu');
require('./fix-euro');
require('./setupCheckboxAndInput');
require('./bootstrap-show-password.min');

$('[name="formule[formule]"]').change(function () {
    console.log(Vue.el);
});
